// My tray
/*!
 * Highlight buttons/selections on click, multi views inside modals and moving between, ...
 */

$(document).ready(function () {
  // Handle clicks on buttons within a .selectable container
  $(document).on("click", "#my-tray .selectable .btn", function () {
    var $this = $(this);
    var $container = $this.closest(".selectable");

    var isOptional = $container.hasClass("selectable-optional");
    var isMulti = $container.hasClass("selectable-multi");

    if (isMulti) {
      if (isOptional) {
        // .selectable.selectable-multi.selectable-optional
        // Toggle freely with no restrictions
        $this.toggleClass("selected");
      } else {
        // .selectable.selectable-multi
        // Toggle, but ensure at least one remains selected
        if ($container.find(".selected").length > 1 || !$this.hasClass("selected")) {
          $this.toggleClass("selected");
        }
      }
    } else if (isOptional) {
      // .selectable.selectable-optional
      // Toggle the selection, allow for none selected but not multiple
      if ($this.hasClass("selected")) {
        $this.removeClass("selected");
      } else {
        $container.find(".btn").removeClass("selected");
        $this.addClass("selected");
      }
    } else {
      // .selectable (only)
      // Single select with exactly one button always selected
      if (!$this.hasClass("selected")) {
        $container.find(".btn").removeClass("selected");
        $this.addClass("selected");
      }
    }
  });

  // Tabs
  $(document).on("click", "#my-tray [id^=narocilaZavihki]l", function (event) {
    event.preventDefault();
    $(this).tab("show");
  });

  // Switch to first tab (home) and close modal
  $(document).on("click", "#my-tray .btn-modal-close", function (event) {
    var $modal = $(this).closest(".modal");
    $modal.find("[id^=narocilaZavihki] .nav-link:first").tab("show");
    $modal.modal("hide");
  });

  // Switch to first tab (home)
  $(document).on("click", "#my-tray .btn-modal-home", function (event) {
    var $modal = $(this).closest(".modal");
    $modal.find("[id^=narocilaZavihki] .nav-link:first").tab("show");
  });

  // Button for opening the second tab
  $(document).on("click", "#my-tray .btn-tab-priloga", function () {
    var $modal = $(this).closest(".modal");
    $modal.find(".nav-link:eq(1)").tab("show");
  });

  // Button for opening the third tab
  $(document).on("click", "#my-tray .btn-tab-dodatek", function () {
    var $modal = $(this).closest(".modal");
    $modal.find(".nav-link:eq(2)").tab("show");
  });

  // Button for opening the fourth tab
  $(document).on("click", "#my-tray .btn-tab-preklici", function () {
    var $modal = $(this).closest(".modal");
    $modal.find(".nav-link:eq(3)").tab("show");
  });

  // Button for opening the rating tab
  $(document).on("click", "#my-tray .btn-tab-rating", function () {
    var $modal = $(this).closest(".modal");
    $modal.find(".nav-link:eq(1)").tab("show");
  });

  // Set up event listener for tab show events within modals
  $(document).on("shown.bs.tab", "#my-tray .modal a.nav-link", function (e) {
    var $activeTab = $(e.target); // This is the newly activated tab
    var $modal = $activeTab.closest(".modal");
    var $modalFooter = $modal.find(".modal-footer");

    // Check if the active tab is the first in its list
    if ($activeTab.parent().index() === 0) {
      $modalFooter.show(); // Show the modal footer if the first or second tab is active
    } else {
      $modalFooter.hide(); // Hide the modal footer if any other tab is active
    }
  });

  // Deselect all
  // Handle clicks on the .btn-deselect-all button within modals
  $(document).on("click", "#my-tray .btn-deselect-all", function () {
    var $this = $(this);
    var $currentTab = $this.closest(".tab-pane"); // Find the closest tab-pane containing the button

    // Deselect all selected buttons within this specific tab only
    $currentTab.find(".btn.selected").removeClass("selected");
  });

  // Highlight canceled meals
  // When a div that triggers a modal is clicked
  $(document).on("click", '#my-tray [data-toggle="modal"]', function () {
    var openerKey = $(this).data("opener"); // Get the data-opener value of the div
    var targetModal = $(this).data("target"); // Get the target modal
    $(targetModal).data("opener", openerKey); // Store the opener data in the modal's data
  });

  // When the save-close button in a modal is clicked
  //$('#my-tray .btn-save-close').on('click', function() {
  $(document).on("click", "#my-tray .btn-save-close", function () {
    var $modal = $(this).closest(".modal");
    var openerKey = $modal.data("opener"); // Retrieve the stored opener data
    var $currentOpener = $('[data-opener="' + openerKey + '"]'); // The div that triggered the modal
  });

  // Listen for clicks on .btn-save-close within any modal
  $(document).on("click", "#my-tray .btn-modal-close", function () {
    var $modal = $(this).closest(".modal");
    var openerKey = $modal.data("opener"); // Retrieve the stored opener data
    var $openerDiv = $('[data-opener="' + openerKey + '"]'); // The div that triggered the modal

    // Collecting selected options within the modal
    var selectedSideDish = $modal
      .find(".obrok-priloga .selected")
      .map(function () {
        return $(this).text(); // Return the text of each selected button
      })
      .get()
      .join(", "); // Join all selected texts with a comma and a space

    var selectedAdditions = $modal
      .find(".obrok-dodatki .selected")
      .map(function () {
        return $(this).text();
      })
      .get()
      .join(", ");

    // Fallback to "/" if no selections
    selectedSideDish = selectedSideDish || "/";
    selectedAdditions = selectedAdditions || "/";

    // Update the content of <strong> inside .side-dish and .dish-addition in the original opener div
    $openerDiv.find(".side-dish strong").text(selectedSideDish);
    $openerDiv.find(".dish-addition strong").text(selectedAdditions);

    $modal.modal("hide"); // Optionally close the modal
  });
});
